import { Reveal } from "./Reveal";
import { Waveform } from "./Waveform";
import { LANDING } from "@/data/pageCopy";


const { kicker, h2, steps } = LANDING.howItWorks;

export const HowItWorks = () => (
  <section id="how" className="relative py-24 md:py-32 bg-[#0a0a0a] border-t border-white/10" data-testid="how-section">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <Reveal>
        <p className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#5B8CFF] mb-4">{kicker}</p>
        <h2 className="font-heading font-medium tracking-tight text-3xl md:text-4xl lg:text-5xl max-w-2xl text-white">
          {h2}
        </h2>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-3 border border-white/10 bg-white/[0.02]">
        {steps.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div className={`group h-full p-8 md:p-10 ${i < 2 ? "md:border-r" : ""} border-white/10 hover:bg-white/[0.04] transition-colors duration-300`}>
              <div className="flex items-center justify-between">
                <span className="font-heading font-medium text-5xl text-white/10 group-hover:text-white transition-colors">{s.n}</span>
                <s.icon className="text-neutral-500 group-hover:text-white transition-colors" size={24} />
              </div>
              <h3 className="mt-8 font-heading font-semibold text-xl text-white">{s.title}</h3>
              <p className="mt-3 text-neutral-400 text-sm leading-relaxed">{s.body}</p>
              {i === 1 && (
                <div className="mt-6 opacity-80">
                  <Waveform bars={28} height={34} color="#ffffff" />
                </div>
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
